import type { BaseComponentProps, WithChildren } from "@neru/types";

interface RowProps extends BaseComponentProps, WithChildren {
  style?: object;
}

export const Row = ({
  children,
  className = "",
  "data-testid": testId,
  ...props
}: RowProps) => (
  <div
    className={`
      flex flex-row

      ${className}
    `}
    data-testid={testId}
    {...props}
  >
    {children}
  </div>
);
